import React, { useState, useEffect, useContext, useMemo } from "react";

import { OverlayTrigger, Tooltip, Dropdown } from "react-bootstrap";

import { RiDeleteBin5Line } from "react-icons/ri";
import { SelectPeriodInterval } from "./PeriodInputs";

import { PACreateContext } from "../../../Contexts/PAContext";

import TagsList from "../../../../../PeopleCraft/TagsList";
import { InfoTooltip, tooltipContent } from "./InfoTooltip";
import { AbsolutePeriod } from "./AbsolutePeriod";

export const ATTRIBUTE_OPTIONS = {
  departamento: "Departamento",
  email: "E-mail",
  cargo: "Cargo",
  unidade: "Unidade",
  filial: "Filial",
  dataAdmissao: "Data admissão",
};

export const METHOD_OPTIONS_LOGIC = {
  CONTAINS: "Contém",
  EXACT_MATCH: "É igual",
};

export const PERIOD_OPTIONS = {
  ABSOLUTE: "Período Absoluto",
  RELATIVE: "Período Relativo",
};

const PERIOD_TYPE_OPTIONS = {
  today: "Hoje",
  pastDays: "Dias passados",
  futureDays: "Dias à frente",
  custom: "Personalizado",
};

const CreateNewCondiciones = ({ rule, condicione }) => {
  const [tags, setTags] = useState([]);
  const [removeAtivado, setRemoveAtivado] = useState(true);
  const [changeAttribute, setChangeAttribute] = useState("departamento");
  const [changeMethod, setChangeMethod] = useState("CONTAINS");
  const [initExecuted, setInitExecuted] = useState(false);
  const [erroAttribute, setErroAttribute] = useState(false);
  const [erroTags, setErroTags] = useState(false);

  const { containerRules, setContainerRules, openConfirmModal } = useContext(PACreateContext);

  const filterType = (type, elem = null) => {

    if (type === "dateAbsolute") {
      return elem;
    }
    if (type === "value") {
      return elem.map((it) => {

        if (it && typeof it === 'object' && (it.start !== undefined || it.end !== undefined)) {
          return { title: `${it.start || ''} - ${it.end || ''}` };
        }
        if (it?.title) {
          return it;
        }

        return { title: it };
      });
    }

    return (
      ATTRIBUTE_OPTIONS[type] ||
      METHOD_OPTIONS_LOGIC[type] ||
      PERIOD_OPTIONS[type] ||
      PERIOD_TYPE_OPTIONS[type] ||
      type
    );
  };

  const removeCondicione = () => {
    openConfirmModal({
      text: `Você tem certeza que deseja remover essa condição ?`,
      variantBtn: "danger",
      textBtn: "Remover condição",
      fnc: () => {
        const removeFilter = containerRules.map((it) => {
          if (it === rule) {
            if (it.items.length > 1) {
              const items = it.items.filter((el) => el !== condicione);
              it.items = items;
            }
          }

          return it;
        });

        setContainerRules(removeFilter);
      },
    });
  };

  const determinePeriodType = (_start, _end) => {
    const getType = (val) => {
      if (val < 0) {
        return "pastDays";
      } else if (val > 0) {
        return "futureDays";
      }
    };

    if (_start === 0 && _end === 0) {
      return { periodType: "today" };
    } else if (_start < 0 && _end === 0) {
      return { periodType: "pastDays", start: _start };
    } else if (_start === 0 && _end > 0) {
      return { periodType: "futureDays", end: _end };
    } else {
      const startType = getType(_start);
      const endType = getType(_end);
      return {
        periodType: "custom",
        start: _start,
        end: _end,
        periodCustomFromType: startType,
        periodCustomToType: endType,
      };
    }
  };

  const filterDropdown = () => {
    /// control de quantidade de Condicionais > 1 tem remove
    const cRS = containerRules.filter((it) => it === rule && it.items.length > 1).length === 0;
    setRemoveAtivado(!cRS);

    /// controle de datas
    containerRules.forEach((it) => {
      if (it === rule) {
        const condicioneFilter = it.items.map((el) => {
          if (el === condicione) {
            if (el.erroAttribute) setErroAttribute(el.erroAttribute);
            if (el.erroValue) setErroTags(el.erroValue);

            if (el.method) {
              setChangeMethod(el.method);
            }

            if (el.attribute) {
              setChangeAttribute(el.attribute);
              el.erroAttribute = false;
              setErroAttribute(false);
            }

            if (
              !initExecuted &&
              el.attribute === "dataAdmissao" &&
              el.method === "RELATIVE" &&
              !el.periodType
            ) {
              const { start = 0, end = 0 } = (el?.value || [])[0] || {};
              const _start = Number(start ?? 0);
              const _end = Number(end ?? 0);

              Object.assign(el, determinePeriodType(_start, _end));
            }

            if (el.value && el.value.length > 0) {
              setTags(filterType("value", el.value));
              el.erroValue = false;
              setErroTags(false);
            }
          }

          return el;
        });

        it.items = condicioneFilter;
      }

      return it;
    });

    setInitExecuted(true);
  };

  const selectDropdown = (select, type) => {
    const itSelec = type === "value" ? filterType("value", select) : select;
    const res = containerRules.map((it) => {
      if (it === rule) {
        it.items = it.items.map((el) => {
          if (el === condicione) el[type] = itSelec;
          return el;
        });
      }
      return it;
    });
    setContainerRules(res);
  };

  const renderMethodDropdown = () => {
    let options = [];
    let placeholder = "";
    if (changeAttribute === "dataAdmissao") {
      options = Object.entries(PERIOD_OPTIONS);
      placeholder = PERIOD_OPTIONS[changeMethod] || "Tipo de período";
    } else {
      options = Object.entries(METHOD_OPTIONS_LOGIC);
      placeholder = METHOD_OPTIONS_LOGIC[changeMethod] || "Selecione o método";
    }

    return (
      <Dropdown
        onSelect={(e) => selectDropdown(e, "method")}
        style={changeAttribute === "dataAdmissao" ? { width: "11rem" } : {}}
        className={`${condicione?.erroMethod ? "erroStatus" : ""}`}
      >
        <Dropdown.Toggle
          variant="outline-secondary"
          id={changeAttribute === "dataAdmissao" ? "campo-periodo" : "campo-contem"}
          className={`${condicione?.erroMethod ? "is-invalid" : ""}`}
        >
          {placeholder}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {options.map(([key, label]) => (
            <Dropdown.Item eventKey={key} key={key}>
              {label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const onChangeAbsoluteDate = (value) => {
    selectDropdown(value, "dateAbsolute");
  };

  const renderSelectPeriod = () =>
    changeAttribute === "dataAdmissao" &&
    changeMethod === "RELATIVE" && (
      <Dropdown
        onSelect={(e) => selectDropdown(e, "periodType")}
        variant="outline-secondary"
        id="tipo-periodo"
        style={{ width: "12rem" }}
        className={`${condicione?.erroPeriodType ? "erroStatus" : ""}`}
      >
        <Dropdown.Toggle
          variant="outline-secondary"
          id="campo-selecione-periodo"
          className={`${condicione?.erroPeriodType ? "is-invalid" : ""}`}
        >
          {PERIOD_TYPE_OPTIONS[condicione?.periodType] || "Selecione o período"}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {Object.entries(PERIOD_TYPE_OPTIONS).map(([key, label]) => (
            <Dropdown.Item
              eventKey={key}
              key={key}
              onSelect={(e) => {
                selectDropdown(e, "periodType");
              }}
            >
              {label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );

  const valueAbsoluteDefault = useMemo(() => {
    if (condicione?.value && condicione.value[0]?.start && condicione.value[0]?.end) {
      return {
        start: condicione.value[0].start,
        end: condicione.value[0].end,
      };
    }
    return {
      start: null,
      end: null,
    };
  }, [condicione?.value]);

  const onClearErrors = (errorType) => {
    const res = containerRules.map((it) => {
      if (it === rule) {
        it.items = it.items.map((el) => {
          if (el === condicione) {
            el[errorType] = false;
          }
          return el;
        });
      }
      return it;
    });
    setContainerRules(res);
  };

  useEffect(() => {
    if (containerRules) {
      filterDropdown();
    }
  }, [containerRules]);

  useEffect(() => {
    setChangeMethod((prev) =>
      changeAttribute === "dataAdmissao"
        ? Object.keys(PERIOD_OPTIONS).includes(prev)
          ? prev
          : "ABSOLUTE"
        : Object.keys(METHOD_OPTIONS_LOGIC).includes(prev)
        ? prev
        : "CONTAINS"
    );
  }, [changeAttribute]);

  return (
    <div className="createNewCondicoes">
      <Dropdown
        onSelect={(e) => {
          selectDropdown(e, "attribute");
        }}
        className={`${erroAttribute || condicione?.erroAttribute ? "erroStatus" : ""}`}
      >
        <Dropdown.Toggle
          variant="outline-secondary"
          id="campo-perfil"
          className={`${erroAttribute || condicione?.erroAttribute ? "is-invalid" : ""}`}
        >
          {filterType(changeAttribute)}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {Object.entries(ATTRIBUTE_OPTIONS).map(([key, label]) => (
            <Dropdown.Item eventKey={key} key={key}>
              {label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>

      {renderMethodDropdown()}

      {changeAttribute === "dataAdmissao" && changeMethod === "RELATIVE" && (
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
            <InfoTooltip content={tooltipContent} />
          </div>
        </div>
      )}

      {renderSelectPeriod()}

      {changeMethod === "RELATIVE" && (
        <SelectPeriodInterval
          changeAttribute={changeAttribute}
          changeMethod={changeMethod}
          condicione={condicione}
          selectDropdown={selectDropdown}
          onClearErrors={onClearErrors}
          {...(condicione || {})}
        />
      )}

      {changeMethod === "ABSOLUTE" && (
        <AbsolutePeriod
          error={condicione?.erroCustomAbsolute}
          value={valueAbsoluteDefault}
          onChange={onChangeAbsoluteDate}
        />
      )}

      {"dataAdmissao" !== changeAttribute && (
        <div className={`container-tags ${erroTags || condicione?.erroValue ? "erroStatus" : ""}`}>
          <TagsList
            tagsInit={tags}
            tagsReturn={(e) => {
              selectDropdown(e, "value");
            }}
          />
        </div>
      )}

      <div className="spaceRemove">
        {removeAtivado && (
          <OverlayTrigger
            placement={"top"}
            overlay={
              <Tooltip style={{ lineHeight: 1.2 }} id={`tooltip-top`}>
                {"Excluir Condição"}
              </Tooltip>
            }
          >
            <button className="removeCondicao" type="button" onClick={removeCondicione}>
              <RiDeleteBin5Line />
            </button>
          </OverlayTrigger>
        )}
      </div>
    </div>
  );
};

export default CreateNewCondiciones;
